import { render, staticRenderFns } from "./NightDifference.vue?vue&type=template&id=1013d384&"
import script from "./NightDifference.vue?vue&type=script&lang=ts&"
export * from "./NightDifference.vue?vue&type=script&lang=ts&"
import style0 from "./NightDifference.vue?vue&type=style&index=0&id=1013d384&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports